export default __webpack_public_path__ + "static/media/folders.f2d7b0aa.svg";